export const data = {
  15: { Counterhate: null, Hate: 1.0, Neutral: 86.0, Other: 11.0 },
  16: { Counterhate: null, Hate: 3.0, Neutral: 76.0, Other: 9.0 },
  17: { Counterhate: null, Hate: 1.0, Neutral: 89.0, Other: 18.0 },
  18: { Counterhate: null, Hate: 1.0, Neutral: 111.0, Other: 27.0 },
  19: { Counterhate: null, Hate: null, Neutral: 85.0, Other: 13.0 },
  20: { Counterhate: 1.0, Hate: 12.0, Neutral: 117.0, Other: 28.0 },
  21: { Counterhate: null, Hate: 17.0, Neutral: 155.0, Other: 48.0 },
  22: { Counterhate: 3.0, Hate: 17.0, Neutral: 414.0, Other: 63.0 },
  23: { Counterhate: 7.0, Hate: 103.0, Neutral: 1232.0, Other: 153.0 },
  24: { Counterhate: 12.0, Hate: 166.0, Neutral: 3726.0, Other: 472.0 },
  25: { Counterhate: 25.0, Hate: 160.0, Neutral: 4292.0, Other: 505.0 },
  26: { Counterhate: 26.0, Hate: 183.0, Neutral: 4694.0, Other: 591.0 },
  27: { Counterhate: 32.0, Hate: 125.0, Neutral: 4944.0, Other: 481.0 },
  28: { Counterhate: 38.0, Hate: 162.0, Neutral: 6216.0, Other: 608.0 },
  29: { Counterhate: 68.0, Hate: 391.0, Neutral: 9485.0, Other: 1210.0 },
  30: { Counterhate: 77.0, Hate: 380.0, Neutral: 10476.0, Other: 1361.0 },
  31: { Counterhate: 94.0, Hate: 386.0, Neutral: 10562.0, Other: 1342.0 },
  32: { Counterhate: 46.0, Hate: 144.0, Neutral: 3540.0, Other: 556.0 },
  33: { Counterhate: 25.0, Hate: 167.0, Neutral: 3547.0, Other: 574.0 },
  34: { Counterhate: 23.0, Hate: 152.0, Neutral: 4096.0, Other: 553.0 },
  35: { Counterhate: 44.0, Hate: 185.0, Neutral: 5048.0, Other: 693.0 },
  36: { Counterhate: 25.0, Hate: 160.0, Neutral: 4878.0, Other: 556.0 },
  37: { Counterhate: 22.0, Hate: 212.0, Neutral: 5138.0, Other: 651.0 },
  38: { Counterhate: 23.0, Hate: 217.0, Neutral: 4534.0, Other: 657.0 },
  39: { Counterhate: 27.0, Hate: 230.0, Neutral: 3982.0, Other: 587.0 },
  40: { Counterhate: 23.0, Hate: 208.0, Neutral: 3721.0, Other: 536.0 },
  41: { Counterhate: 28.0, Hate: 213.0, Neutral: 5080.0, Other: 679.0 },
  42: { Counterhate: 25.0, Hate: 236.0, Neutral: 5289.0, Other: 652.0 },
  43: { Counterhate: 29.0, Hate: 219.0, Neutral: 4814.0, Other: 585.0 },
  44: { Counterhate: 34.0, Hate: 238.0, Neutral: 6072.0, Other: 724.0 },
  45: { Counterhate: 32.0, Hate: 186.0, Neutral: 5249.0, Other: 654.0 },
  46: { Counterhate: 25.0, Hate: 170.0, Neutral: 4066.0, Other: 528.0 },
  47: { Counterhate: 18.0, Hate: 183.0, Neutral: 3758.0, Other: 549.0 },
  48: { Counterhate: 28.0, Hate: 227.0, Neutral: 4984.0, Other: 656.0 },
  49: { Counterhate: 24.0, Hate: 106.0, Neutral: 4118.0, Other: 365.0 },
  50: { Counterhate: 27.0, Hate: 229.0, Neutral: 5500.0, Other: 663.0 },
  51: { Counterhate: 28.0, Hate: 238.0, Neutral: 6057.0, Other: 674.0 },
  52: { Counterhate: 18.0, Hate: 174.0, Neutral: 5951.0, Other: 612.0 },
  53: { Counterhate: 20.0, Hate: 143.0, Neutral: 5230.0, Other: 494.0 },
  54: { Counterhate: 9.0, Hate: 79.0, Neutral: 4522.0, Other: 292.0 },
  55: { Counterhate: 23.0, Hate: 189.0, Neutral: 8355.0, Other: 670.0 },
  56: { Counterhate: 23.0, Hate: 176.0, Neutral: 11747.0, Other: 946.0 },
  57: { Counterhate: 24.0, Hate: 122.0, Neutral: 8452.0, Other: 702.0 },
  58: { Counterhate: 41.0, Hate: 171.0, Neutral: 17415.0, Other: 1504.0 },
  59: { Counterhate: 83.0, Hate: 247.0, Neutral: 19261.0, Other: 1824.0 },
  60: { Counterhate: 109.0, Hate: 328.0, Neutral: 24001.0, Other: 2439.0 },
  61: { Counterhate: 85.0, Hate: 253.0, Neutral: 18945.0, Other: 1750.0 },
  62: { Counterhate: 60.0, Hate: 143.0, Neutral: 15586.0, Other: 1185.0 },
  63: { Counterhate: 100.0, Hate: 263.0, Neutral: 25109.0, Other: 1897.0 },
  64: { Counterhate: 118.0, Hate: 271.0, Neutral: 22904.0, Other: 1624.0 },
  65: { Counterhate: 81.0, Hate: 171.0, Neutral: 21787.0, Other: 1538.0 },
  66: { Counterhate: 55.0, Hate: 117.0, Neutral: 17562.0, Other: 1219.0 },
  67: { Counterhate: 70.0, Hate: 143.0, Neutral: 19921.0, Other: 1470.0 },
  68: { Counterhate: 52.0, Hate: 126.0, Neutral: 16398.0, Other: 1249.0 },
  69: { Counterhate: 76.0, Hate: 201.0, Neutral: 19219.0, Other: 1481.0 },
  70: { Counterhate: 113.0, Hate: 229.0, Neutral: 18494.0, Other: 1476.0 },
  71: { Counterhate: 100.0, Hate: 168.0, Neutral: 17472.0, Other: 1271.0 },
  72: { Counterhate: 76.0, Hate: 281.0, Neutral: 16424.0, Other: 1453.0 },
  73: { Counterhate: 76.0, Hate: 360.0, Neutral: 14634.0, Other: 1355.0 },
  74: { Counterhate: 62.0, Hate: 215.0, Neutral: 13025.0, Other: 1113.0 },
  75: { Counterhate: 52.0, Hate: 168.0, Neutral: 13255.0, Other: 1144.0 },
  76: { Counterhate: 82.0, Hate: 167.0, Neutral: 10000.0, Other: 940.0 },
  77: { Counterhate: 465.0, Hate: 849.0, Neutral: 11270.0, Other: 2176.0 },
  78: { Counterhate: 524.0, Hate: 1029.0, Neutral: 11023.0, Other: 2299.0 },
  79: { Counterhate: 379.0, Hate: 1027.0, Neutral: 11782.0, Other: 2349.0 },
  80: { Counterhate: 219.0, Hate: 592.0, Neutral: 10883.0, Other: 1518.0 },
  81: { Counterhate: 120.0, Hate: 465.0, Neutral: 9772.0, Other: 1145.0 },
  82: { Counterhate: 118.0, Hate: 354.0, Neutral: 9593.0, Other: 1170.0 },
  83: { Counterhate: 180.0, Hate: 395.0, Neutral: 10486.0, Other: 1308.0 },
  84: { Counterhate: 123.0, Hate: 412.0, Neutral: 11795.0, Other: 1237.0 },
  85: { Counterhate: 79.0, Hate: 390.0, Neutral: 12580.0, Other: 1188.0 },
  86: { Counterhate: 113.0, Hate: 713.0, Neutral: 12848.0, Other: 1584.0 },
  87: { Counterhate: 83.0, Hate: 461.0, Neutral: 12385.0, Other: 1439.0 },
  88: { Counterhate: 48.0, Hate: 279.0, Neutral: 12036.0, Other: 1138.0 },
  89: { Counterhate: 72.0, Hate: 369.0, Neutral: 10860.0, Other: 1110.0 },
  90: { Counterhate: 84.0, Hate: 555.0, Neutral: 12766.0, Other: 1259.0 },
  91: { Counterhate: 70.0, Hate: 471.0, Neutral: 12931.0, Other: 1254.0 },
  92: { Counterhate: 60.0, Hate: 602.0, Neutral: 13130.0, Other: 1379.0 },
  93: { Counterhate: 53.0, Hate: 444.0, Neutral: 11309.0, Other: 1203.0 },
  94: { Counterhate: 59.0, Hate: 350.0, Neutral: 13087.0, Other: 1152.0 },
  95: { Counterhate: 37.0, Hate: 446.0, Neutral: 12213.0, Other: 1179.0 },
  96: { Counterhate: 50.0, Hate: 369.0, Neutral: 12132.0, Other: 1276.0 },
  97: { Counterhate: 55.0, Hate: 327.0, Neutral: 13991.0, Other: 1173.0 },
  98: { Counterhate: 75.0, Hate: 351.0, Neutral: 9955.0, Other: 988.0 },
  99: { Counterhate: 53.0, Hate: 359.0, Neutral: 10858.0, Other: 1003.0 },
  100: { Counterhate: 47.0, Hate: 284.0, Neutral: 11242.0, Other: 991.0 },
  101: { Counterhate: 34.0, Hate: 123.0, Neutral: 9246.0, Other: 705.0 },
  102: { Counterhate: 74.0, Hate: 373.0, Neutral: 8821.0, Other: 997.0 },
  103: { Counterhate: 43.0, Hate: 343.0, Neutral: 4001.0, Other: 670.0 },
  104: { Counterhate: 36.0, Hate: 324.0, Neutral: 4376.0, Other: 605.0 },
  105: { Counterhate: 29.0, Hate: 330.0, Neutral: 4713.0, Other: 570.0 },
  106: { Counterhate: 29.0, Hate: 337.0, Neutral: 5836.0, Other: 748.0 },
  107: { Counterhate: 54.0, Hate: 380.0, Neutral: 12475.0, Other: 1138.0 },
  108: { Counterhate: 66.0, Hate: 622.0, Neutral: 11940.0, Other: 1398.0 },
};
